// ── Surface hierarchy (darkest → lightest) ──
export const DARK_BG_DEFAULT = '#15181E'; // base background (chat timeline)
export const DARK_BG_ELEVATED = '#12151B'; // header, footer, sidebar (subtle lift above default)
export const DARK_BG_SURFACE = '#171A21'; // elevated panels
export const DARK_BG_CARD = '#1E2128'; // cards, table containers, Paper
export const DARK_BG_INPUT = '#252932'; // inputs, tooltips, outlined buttons

// ── Text ──
export const DARK_TEXT_PRIMARY = '#E8EAED';
export const DARK_TEXT_SECONDARY = '#9AA0AA';
export const DARK_TEXT_DISABLED = '#6B7280';

// ── Borders ──
export const DARK_BORDER = 'rgba(255,255,255,0.08)';
